(() => {
  const storageKey = 'giaOraNewsletterClosedAt';
  const hiddenFor = 14 * 24 * 60 * 60 * 1000;

  const initializePopup = (popup) => {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    let lastClosed = 0;
    try {
      lastClosed = Number(window.localStorage.getItem(storageKey) || 0);
    } catch (_error) {
      lastClosed = 0;
    }

    if (Date.now() - lastClosed < hiddenFor) return;

    const closeButtons = popup.querySelectorAll('[data-gia-popup-close]');
    const emailInput = popup.querySelector('input[type="email"]');
    const form = popup.querySelector('form');
    let hasOpened = false;

    const rememberClose = () => {
      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (_error) {
        // The popup still works when local storage is unavailable.
      }
    };

    const close = () => {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gia-popup-open');
      rememberClose();
    };

    const open = () => {
      if (hasOpened || !popup.hidden) return;
      hasOpened = true;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gia-popup-open');
      window.setTimeout(() => emailInput?.focus({ preventScroll: true }), 120);
    };

    const openOnScroll = () => {
      if (window.scrollY > window.innerHeight * 0.65) {
        window.removeEventListener('scroll', openOnScroll);
        open();
      }
    };

    closeButtons.forEach((button) => button.addEventListener('click', close));
    form?.addEventListener('submit', rememberClose);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) close();
    });
    window.addEventListener('scroll', openOnScroll, { passive: true });
    window.setTimeout(open, 6500);
  };

  const initialize = () => {
    document.querySelectorAll('[data-gia-newsletter-popup]').forEach(initializePopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
